import React from 'react'
import Fwcard from './Fwcard'
import './fwcardcontainer.css'
const Fwcardcontainer = () => {
    return (
        <>
            <div className='container cont-mt'>
                <div class="fw-grid-container">
                    <div class="fw-item1">
                        <Fwcard />
                    </div>
                    <div class="fw-item2">
                        <Fwcard />
                    </div>
                    <div class="fw-item3">
                        <Fwcard />
                    </div>
                    <div class="fw-item4">
                        <Fwcard />
                    </div>
                    <div class="fw-item5">
                        <Fwcard />
                    </div>
                    <div class="fw-item6">
                        <Fwcard />
                    </div>
                    <div class="fw-item7">
                        <Fwcard />
                    </div>
                    <div class="fw-item8">
                        <Fwcard />
                    </div>



                </div>
            </div>

        </>
    )
}

export default Fwcardcontainer